import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PasswordUpdateComponent } from "../components";

@Injectable()
export class PasswordUpdateFacade {
  constructor(private readonly dialog: MatDialog) {}

  passwordUpdate() {
    return this.dialog.open(PasswordUpdateComponent);
  }
}
